import { Box, CircularProgress, Grid, Typography, Button, Input, Modal } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';
import { toast } from 'react-toastify';

import Header from './header';
import { setMall, setStore } from '../../../actions/admin/uploadScrappedPromoAction';
import { IsEmpty } from '../../../common/checks';
import MaterialDatePicker from '../../global/form/MaterialDatePicker';
import apiService from '../../../services.js/apiService';
import SuccessScrappedPromo from './success';
import Loading from '../../global/Loading';

const maxImagesPerPost = 3;
class UploadDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      images:       [],
      dateFrom:     null,
      dateTo:       null,
      displayImage: null, // 'https://d1aq8vpj94zs31.cloudfront.net/10b5a4ac-b518-42b9-a04c-a458dcdbcad3_image.jpeg',
      showSucccess: false,
      loading:      false,
    };

    this.clearStoreSelected = this.clearStoreSelected.bind(this);
    this.handleImagesSelect = this.handleImagesSelect.bind(this);
    this.onUploadClick = this.onUploadClick.bind(this);
    this.hideModalImage = this.hideModalImage.bind(this);
    this.deleteImage = this.deleteImage.bind(this);
  }

  componentDidMount() {
  }

  clearStoreSelected() {
    this.props.setStoreDispatcher('', '', '', '');
  }

  handleImagesSelect(evt) {
    const { files } = evt.target;
    for (let i = 0; i < files.length; i += 1) {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        const tmp = this.state.images;
        tmp.push({
          file: files[i],
          name: files[i].name,
          tyle: files[i].type,
          uri:  reader.result,
        });

        this.setState({ images: tmp });
      });
      reader.readAsDataURL(files[i]);
    }
  }

  async onUploadClick() {
    try {
      if (IsEmpty(this.state.images)) {
        toast.error('Please upload at least one image', { autoClose: 5000 });
        return;
      }
      if (this.state.images.length > maxImagesPerPost) {
        toast.error(`Max. image upload of ${maxImagesPerPost} exceeded. Please delete some image.`, { autoClose: 5000 });
        return;
      }

      if (!IsEmpty(this.state.dateFrom) && IsEmpty(this.state.dateTo)) {
        toast.error('Please select the end date of this promo', { autoClose: 5000 });
        return;
      }
      if (IsEmpty(this.state.dateFrom) && !IsEmpty(this.state.dateTo)) {
        toast.error('Please select the start date of this promo', { autoClose: 5000 });
        return;
      }

      if (!IsEmpty(this.state.dateFrom) && !IsEmpty(this.state.dateTo)) {
        // check date
        const dateFrom = new Date(this.state.dateFrom);
        const dateTo = new Date(this.state.dateTo);
        if (dateFrom > dateTo) {
          toast.error('Date error. End date cannot be earlier than start date.', { autoClose: 5000 });
          return;
        }
        if (dateTo < new Date()) {
          toast.error('Date error. End date cannot be in the past.', { autoClose: 5000 });
          return;
        }
      }

      this.setState({ loading: true });

      const formData = new FormData();
      formData.append('brand', this.props.store.name);
      formData.append('pageId', this.props.store.id);
      formData.append('outletIds', `${this.props.store.outletId}`);
      formData.append('outlets', JSON.stringify({
        id:         this.props.store.outletId,
        mallName:   this.props.mall.name,
        postalCode: this.props.store.postalCode,
      }));
      formData.append('score', 1);
      // formData.append('promoStartDate', this.state.dateFrom);
      // formData.append('promoTillDate', this.state.dateTo);

      for (let i = 0; i < this.state.images.length; i += 1) {
        formData.append('images', this.state.images[i].file);
      }

      console.log('Uploading...');
      await apiService.createScrappedPromo(formData);
      this.setState({ loading: false, images: [], dateFrom: null, dateTo: null, showSucccess: true });
    } catch (err) {
      console.log('Error uploading scrapped promo: ');
      console.log(err);
      this.setState({ loading: false });
      toast.error(String(err));
    }
  }

  hideModalImage() {
    this.setState({ displayImage: null });
  }

  deleteImage(uri) {
    for (let i = 0; i < this.state.images.length; i += 1) {
      const image = this.state.images[i];
      if (image.uri === uri) {
        this.state.images.splice(i, 1);
        break;
      }
    }
  }

  render() {
    if (this.state.showSucccess) {
      return (
        <SuccessScrappedPromo
          name={this.props.store.name}
          onSelectYes={() => this.setState({ showSucccess: false })}
          onSelectNo={() => this.clearStoreSelected()}
        />
      );
    } else {
      return (
        <Grid>
          <Header
            title="(Step 3/3) Upload Details"
            showBackButton
            onBackPress={this.clearStoreSelected}
          />

          <Grid item container direction="column" className="mt-5" style={{ alignItems: 'center' }}>
            <Grid item container direction="row">
              {/* <Typography variant="h5" style={{ paddingLeft: 20 }}>Promo Photos</Typography> */}
              <Typography variant="h5" style={{ paddingLeft: 0 }}>
                <Box fontWeight="fontWeightBold">
                  Promo Photos (max.
                  {' '}
                  {maxImagesPerPost}
                  )

                </Box>
              </Typography>
            </Grid>

            <Input
              id="file-selector"
              type="file"
              accept="image/*"
              inputProps={{ multiple: true }}
              onChange={this.handleImagesSelect}
              style={{
                backgroundColor: 'blue',
                color:           'white',
                display:         'none',
              }}
            />

            <Grid xs={12} md={3} />
            <Grid item xs={12} md={6} className="mt-3" style={{ alignSelf: 'center' }}>
              <label htmlFor="file-selector" style={{ width: '100%' }}>
                <Button variant="contained" color="primary" fullWidth style={{ height: 40 }} component="span">
                  Select Photos
                </Button>
              </label>
            </Grid>
          </Grid>

          <Grid className="mt-3">
            <Grid key="igc" item container>
              {
              _.map(this.state.images, (item, idx2) => (
                <Grid item key={`igci-${idx2}`} item xs={6} md={4} style={{ paddingTop: '50%', overflow: 'hidden', height: 0, position: 'relative' }}>
                  <img
                    src={item.uri}
                    alt="Uploaded"
                    style={{ width: '100%', height: '100%', objectFit: 'contain',  right: 2, left: 2, bottom: 2, position: 'absolute' }}
                    onClick={() => this.setState({ displayImage: item.uri })}
                  />
                </Grid>
              ))
              }
            </Grid>
          </Grid>

          {/* <Grid item container direction="column" className="mt-5 mb-3" style={{ alignItems: 'center', paddingTop: 20 }}>
            <Grid item container direction="column" xs={12}>
              <Typography variant="h5">
                <Box fontWeight="fontWeightBold">Promo Period</Box>
              </Typography>
              <Typography variant="subtitle1">(If applicable)</Typography>
            </Grid>

            <Grid container direction="row" style={{ justifyContent: 'center', alignItems: 'center' }}>
              <Grid xs={5} md={4} lg={3}>
                <MaterialDatePicker
                  id="dateFrom"
                  label="Start Date"
                  format="dd MMM yyyy"
                  variant="dialog"
                  value={IsEmpty(this.state.dateFrom) ? null : new Date(this.state.dateFrom)}
                  onChange={(e) => this.setState({ dateFrom: e.toString('yyyy-MM-dd') })}
                />
              </Grid>

              <Grid container direction="row" xs={2} md={2} lg={1} style={{ height: 40, justifyContent: 'center', alignItems: 'flex-end' }}>
                <Typography>to</Typography>
              </Grid>

              <Grid xs={5} md={4} lg={3} style={{ alignItems: 'center', justifyContent: 'center' }}>
                <MaterialDatePicker
                  id="dateTo"
                  label="End Date"
                  format="dd MMM yyyy"
                  variant="dialog"
                  value={IsEmpty(this.state.dateTo) ? null : new Date(this.state.dateTo)}
                  onChange={(e) => this.setState({ dateTo: e.toString('yyyy-MM-dd') })}
                />
              </Grid>
            </Grid>

            <Button
              onClick={() => {
              this.setState({
                dateFrom: null,
                dateTo:   null,
              });
              }}
              style={{ alignSelf: 'center', padding: 20 }}
            >
              Clear selected dates
            </Button>
          </Grid> */}

          <Grid container className="mt-5">
            <Grid xs={12} md={3} />
            <Grid xs={12} md={6}>
              <Button
                variant="contained"
                onClick={this.onUploadClick}
                color="secondary"
                fullWidth
                style={{ height: 40 }}
              >
                Upload
              </Button>
            </Grid>
          </Grid>

          {
            this.state.displayImage && (
              <Grid container direction="row" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100vh', backgroundColor: '#000000', zIndex: 99, padding: 20 }}>
                <Grid item container direction="row" xs={12} style={{ justifyContent: 'center' }}>
                  <Button
                    color="primary"
                    style={{ width: 200, height: 40, marginTop: 10 }}
                    onClick={this.hideModalImage}
                  >
                    <CancelRoundedIcon style={{ color: 'white', fontSize: 50 }} />
                  </Button>
                </Grid>

                <Grid item container direction="row" xs={12} style={{ padding: 20, justifyContent: 'center' }}>
                  <img src={this.state.displayImage} alt="display" style={{  height: '50vh', objectFit: 'contain' }} />
                </Grid>

                <Grid item container direction="row" xs={12} style={{ justifyContent: 'center' }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    style={{ width: 200, height: 40, marginBottom: 10 }}
                    onClick={() => {
                  this.deleteImage(this.state.displayImage);
                  this.setState({ displayImage: null });
                    }}
                  >
                    Delete
                  </Button>
                </Grid>
              </Grid>
            )
          }

          { this.state.loading && <Loading /> }
        </Grid>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  mall:  state.admin.uploadScrappedPromo.mall,
  store: state.admin.uploadScrappedPromo.store,
});

const mapDispatchToProps = (dispatch) => ({
  setMallDispatcher:  (id, name) => dispatch(setMall(id, name)),
  setStoreDispatcher: (id, name, outletId, postalCode) => dispatch(setStore(id, name, outletId, postalCode)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadDetails);
